import React from "react";

import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { nameValidationPattern } from "@gp/common";

import { FormInputField } from "@components-shared/desktop/inputs";

export default function OnboardingRegistrationFirstName(props: {
	labelClassName?: string;
	disabled?: boolean;
}) {
	const { t } = useTranslation("registration");
	const { labelClassName, disabled } = props;

	const { getValues, trigger, clearErrors } = useFormContext();

	return (
		<FormInputField
			id="firstName"
			name="firstName"
			className="form__field u-mar--bottom--reset"
			labelClassName={labelClassName}
			label={t("FIRST_NAME_LABEL")}
			inputClassName="input input--sml input"
			placeholder={t("FIRST_NAME_PLACEHOLDER")}
			pattern={{
				value: nameValidationPattern,
				message: t("INVALID_FIRST_NAME"),
			}}
			validate={{
				passValidate: () => {
					if (getValues("password")) {
						trigger("password");
					} else {
						clearErrors("password");
					}
				},
			}}
			required
			disabled={disabled}
		/>
	);
}
